<script lang="ts">
  import { size } from '$lib/responsive';
  import { createEventDispatcher } from 'svelte';
  import { fade, fly } from '$lib/transitions';

  export let title: string;
  export let className = '';

  const dispatch = createEventDispatcher<{ close: void }>();

  function elasticOut(t: number) {
    t = t / 4;
    return Math.sin((-13.0 * (t + 1.0) * Math.PI) / 2) * Math.pow(3.0, -30.0 * t) + 1.0;
  }
</script>

<div
  class="bg-black opacity-30 fixed md:hidden inset-0"
  transition:fade={{ duration: $size.md ? 0 : 300 }}
/>

<div
  in:fly={{
    y: $size.height,
    duration: $size.md ? 0 : 600,
    easing: elasticOut,
  }}
  out:fly={{
    y: $size.height,
    duration: $size.md ? 0 : 700,
  }}
  class="z-10 fixed md:relative px-6 pt-4 pb-16 md:px-0 md:py-0 shadow-lg md:shadow-none border-t border-grey-aux md:border-t-0 w-full bg-white dark:bg-obsidian -bottom-12 md:bottom-0 left-0 rounded-t-lg {className}"
>
  <button
    type="button"
    class="btn btn-sm btn-grey md:hidden absolute right-6 top-4"
    on:click={() => dispatch('close')}
  >
    <i class="icon icon-close icon-only" />
  </button>

  <h4 class="heading-3 mt-1 mb-3 md:hidden text-center">{title}</h4>
  <slot />
</div>
